import { render } from "./ProfilePage.vue?vue&type=template&id=c2e5d22c&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c2e5d22c"

export default script